import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import ItemMasterTabs from "./ItemMasterTabs";

import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import ItemDataEntryPopup from "../../../../../im/codes/itemDataEntry/common/ItemDataEntryPopup";
import SalesOrderOptionsButton, { OptionsTabType } from "../common/SalesOrderOptionsButton";
import PrintReportMenu from "../common/PrintReportMenu";
const basisType = [
    { ID: 'A', Text: 'Average Cost' },
    { ID: 'L', Text: 'Last Cost' }
]
const statusType = [
    { ID: 'A', Text: 'Active' },
    { ID: 'I', Text: 'InActive' }
]
const taxStatus = [
    { ID: 'Y', Text: 'Yes' },
    { ID: 'N', Text: 'No' }
]
const ItemMasterSearchResultsMain = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "E9AEE3C6-DA19-49D0-B191-4533AA7EB7A7";
    const childRef = useRef();
    const [selectedRow, setSelectedRow] = useState(null);
       const [currentLayout, setCurrentLayout]= useState("Default");
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
   const [showPopup, setShowPopup] = useState({id:null,visible:false});
    const onSelectionChanged =({selectedRowsData}) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
          }
          setSelectedRow(selectedRowData);
          setShowPopup({id:selectedRowData.rowid,visible:false});
    };

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
             ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true} 
                searchEnabled={true}
                columnAutoWidth={true}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <FilterRow visible={true} />
                <Column dataField="warehouseID" caption='Warehouse' ></Column>
                <Column dataField="itemCode" caption='Item' ></Column>
                <Column dataField="description_1" caption='Item Description -1' ></Column>
                <Column dataField="description_2" caption='Item Description -2' ></Column>
                <Column dataField="classCode" caption='Class' ></Column>
                <Column dataField="subClassCode" caption='Sub Class' ></Column>
                <Column dataField="netAvailable" format={{
                    type: 'fixedPoint',
                    precision: 2
                }} caption='Net Available' ></Column>

                <Column dataField="averageCost" caption="Average Cost" format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'USD',
                    useGrouping: true
                }} visible={false}> </Column>

                <Column dataField="available" caption="Available" visible={false} format={{
                    type: 'fixedPoint',
                    precision: 2
                }}></Column>
                <Column dataField="availableDate" caption="Available Dt" dataType="date" visible={false}></Column>
                <Column dataField="costBasis" caption="Cost Basis" visible={false}
                    lookup={{ dataSource: basisType, valueExpr: 'ID', displayExpr: 'Text' }} cellRender={cellData => {
                        switch (cellData.value) {
                            case 'A':
                                return <span>Average Cost</span>;
                            case 'L':
                                return <span>Last Cost</span>;
                            default:
                                return <span>{cellData.value}</span>;
                        }
                    }}
                ></Column>
                <Column dataField="unitValue" caption="Unit Value" visible={false}></Column>
                <Column dataField="unitValueuom" caption="Unit Value UOM" visible={false}></Column>
                <Column dataField="unitVolumeuom" caption="Unit Volume UOM" visible={false}></Column>
                <Column dataField="unitPckg" caption="Unit/Pkg" visible={false}></Column>
                <Column dataField="unitPkguom" caption="Unit/Pkg UOM" visible={false}></Column>

                <Column dataField="unavailable" caption="Unavailable" visible={false} format={{
                    type: 'fixedPoint',
                    precision: 2
                }}></Column>
                <Column dataField="taxstatus" caption="Tax Status" visible={false}
                    lookup={{ dataSource: taxStatus, valueExpr: 'ID', displayExpr: 'Text' }} cellRender={cellData => {
                        switch (cellData.value) {
                            case 'Y':
                                return <span>Yes</span>;
                            case 'N':
                                return <span>No</span>;
                            default:
                                return <span>{cellData.value}</span>;
                        }
                    }}></Column>
                <Column dataField="standardcost" caption="Standard Cost" visible={false}></Column>
                <Column dataField="salemaxquantity" caption="Sale Max Qty" visible={false}></Column>
                <Column dataField="stackheight" caption="Stack Height" visible={false}></Column>
                <Column dataField="reorderMaxQty" caption="Reorder Max Qty" visible={false}></Column>
                <Column dataField="reorderMinQty" caption="Reorder Min Qty" visible={false}></Column>
                <Column dataField="reorderMaxDay" caption="Reorder Max Day" visible={false}></Column>
                <Column dataField="reorderMinDay" caption="Reorder Min Day" visible={false}></Column>
                <Column dataField="reorderCalQty" caption="Reorder Cal Qty" visible={false}></Column>
                <Column dataField="artradediscountflag" caption="AR Trade Disc" visible={false}></Column>
                <Column dataField="artermsdiscountflag" caption="AR Terms Disc" visible={false}></Column>

                <Column dataField="bomExplosionFlag" caption="Bom Explosion Flag" visible={false}></Column>
                <Column dataField="dateExpiration" caption="Expiration Date" dataType="date" visible={false}></Column>
                <Column dataField="careInstructions" caption="Care Instructions" visible={false}></Column>
                <Column dataField="dateIntroduced" caption="Date Introduced" dataType="date" visible={false}></Column>
                <Column dataField="inventoryUnitUom" caption="Inventory Unit Uom" visible={false}></Column>
                <Column dataField="itemSourceFlag" caption="ItemSourceFlag" visible={false}> </Column>
                <Column dataField="locationmaxunitsforwardpick" caption="Max Units Fwd Pick" visible={false}></Column>
                <Column dataField="locationmaxunitsreplenishment" caption="Max Units Repl" visible={false}></Column>
                <Column dataField="minimumsalesquantity" caption="Min Sales Qty" visible={false}></Column>
                <Column dataField="locationminunitsforwardpick" caption="Min Units Fwd Pick" visible={false}></Column>
                <Column dataField="locationminunitsreplenishment" caption="Min Units Repl" visible={false}></Column>
                <Column dataField="wearHouseName" caption="WearHouse Name" visible={false}></Column>

                <Column dataField="userDefinedCode1" caption="Code1" visible={false}> </Column>
                <Column dataField="userDefinedCode2 " caption="Code2" visible={false}></Column>
                <Column dataField="userDefinedCode3 " caption="Code3" visible={false}></Column>
                <Column dataField="userDefinedCode4 " caption="Code4" visible={false}></Column>
                <Column dataField="userDefinedCode5 " caption="Code5" visible={false}></Column>
                <Column dataField="userDefinedCode6 " caption="Code6" visible={false}></Column>
                <Column dataField="userDefinedCode7 " caption="Code7" visible={false}></Column>
                <Column dataField="userDefinedCode8 " caption="Code8" visible={false}></Column>
                <Column dataField="userDefinedCode9 " caption="Code9" visible={false}></Column>
                <Column dataField="userDefinedCode10" caption="Code10" visible={false}></Column>
                <Column dataField="creationUserId " caption="User Created" visible={false}></Column>
                <Column dataField="creationDateTime " caption="Creation Date Time" dataType="date" visible={false}></Column>
                <Column dataField="lastUpdateDateTime" caption="Last Update Date Time" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate1 " caption="Date1" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate2 " caption="Date2" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate3 " caption="Date3" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate4 " caption="Date4" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate5 " caption="Date5" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate6 " caption="Date6" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate7 " caption="Date7" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate8 " caption="Date8" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate9 " caption="Date9" dataType="date" visible={false}></Column>
                <Column dataField="userDefinedDate10" caption="Date10" dataType="date" visible={false}></Column>

                <Column dataField="inReceiving " caption="In Receiving" visible={false}></Column>
                <Column dataField="itemType " caption="Item Type" visible={false}></Column>
                <Column dataField="lastCost " caption="Last Cost" visible={false}></Column>
                <Column dataField="lastUpdateUserId " caption="Last Update User" visible={false}></Column>
                <Column dataField="priceLevelA" caption="Price Level A" visible={false}></Column>
                <Column dataField="priceLevelB" caption="Price Level B" visible={false}></Column>
                <Column dataField="priceLevelC" caption="Price Level C" visible={false}></Column>
                <Column dataField="priceLevelD" caption="Price Level D" visible={false}></Column>
                <Column dataField="priceLevelE" caption="Price Level E" visible={false}></Column>
                <Column dataField="status" caption="Status" visible={false}
                    lookup={{ dataSource: statusType, valueExpr: 'ID', displayExpr: 'Text' }} cellRender={cellData => {
                        switch (cellData.value) {
                            case 'A':
                                return <span>Active</span>;
                            case 'I':
                                return <span>InActive</span>;
                            default:
                                return <span>{cellData.value}</span>;
                        }
                    }}
                ></Column>
                <Column dataField="userDefinedQuantity1 " caption="Quantity1" visible={false}></Column>
                <Column dataField="userDefinedQuantity2 " caption="Quantity2" visible={false}></Column>
                <Column dataField="userDefinedQuantity3 " caption="Quantity3" visible={false}></Column>
                <Column dataField="userDefinedQuantity4 " caption="Quantity4" visible={false}></Column>
                <Column dataField="userDefinedQuantity5 " caption="Quantity5" visible={false}></Column>
                <Column dataField="userDefinedQuantity6 " caption="Quantity6" visible={false}></Column>
                <Column dataField="userDefinedQuantity7 " caption="Quantity7" visible={false}></Column>
                <Column dataField="userDefinedQuantity8 " caption="Quantity8" visible={false}></Column>
                <Column dataField="userDefinedQuantity9 " caption="Quantity9" visible={false}></Column>
                <Column dataField="userDefinedQuantity10" caption="Quantity10" visible={false}></Column>
                <Column dataField="userDefinedReference1" caption="Reference1" visible={false}></Column>
                <Column dataField="userDefinedReference2" caption="Reference2" visible={false}></Column>
                <Column dataField="userDefinedReference3" caption="Reference3" visible={false}></Column>
                <Column dataField="userDefinedReference4" caption="Reference4" visible={false}></Column>
                <Column dataField="userDefinedReference5" caption="Reference5" visible={false}></Column>
                <Column dataField="userDefinedReference6" caption="Reference6" visible={false}></Column>
                <Column dataField="userDefinedReference7" caption="Reference7" visible={false}></Column>
                <Column dataField="userDefinedReference8" caption="Reference8" visible={false}></Column>
                <Column dataField="userDefinedReference9" caption="Reference9" visible={false}></Column>
                <Column dataField="userDefinedReference10" caption="Reference10" visible={false}></Column>
                <Toolbar>
                 <Item location="before">
                     <Button text="Edit" disabled={!showPopup.id} type="default" onClick={()=>setShowPopup(prevFormData=>({...prevFormData, visible:true}))} />
                 </Item>
                <Item location="before">
                     <Button text="Add" type="default" onClick={()=>setShowPopup({id:null, visible:true})}/>
                    </Item>
                    <Item location="before">
                    <PrintReportMenu selectedRecord={selectedRow} />
                    </Item>
                    <Item location="before">
                    <SalesOrderOptionsButton tabType={OptionsTabType.Item} customerId={null} />
                    </Item>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <ItemMasterTabs ref={childRef} accessToken={accessToken}/>
            <ItemDataEntryPopup showPopup={showPopup} setShowPopup={setShowPopup}/>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ItemMasterSearchResultsMain);